import { Sparkles } from "lucide-react";

export default function HeroImageCard({ cardTitle, cardSub }) {
  return (
    <div className="relative">
      <div className="absolute -inset-4 bg-gradient-to-br from-[#1995AD]/30 to-transparent rounded-[2rem] blur-2xl" />
      <div className="relative card-surface overflow-hidden p-0 aspect-[4/5]">
        <img
          src="https://images.unsplash.com/photo-1642018929698-8d86f43ffcd5?crop=entropy&cs=srgb&fm=webp&q=75&w=800&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhaXIlMjBjb25kaXRpb25lciUyMGludGVyaW9yfGVufDB8fHx8MTc4MjAyOTc5Mnww&ixlib=rb-4.1.0"
          alt="Modern AC unit"
          width="800"
          height="1000"
          fetchPriority="high"
          decoding="async"
          className="w-full h-full object-cover"
        />
        <div className="absolute bottom-5 left-5 right-5 backdrop-blur-xl bg-white/85 rounded-2xl p-4 border border-white/60">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-[var(--secondary)]/15 flex items-center justify-center">
              <Sparkles className="w-5 h-5 text-[var(--primary)]" />
            </div>
            <div className="min-w-0">
              <div className="font-bold text-[var(--heading)]">{cardTitle}</div>
              <div className="text-xs text-[var(--muted)]">{cardSub}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
